// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__ieZVE","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__Aj84z"};